import axios from "axios";
import {
    baseUrl,
    requestState,
    translateLocation,
    translateObjectToNumberArray,
    translateObjectToStringArray,
} from "./utils";
import { reset } from "redux-form";
import { showError } from "./error";

export const CLEAR_SIGNUP_STATUS = "CLEAR_SIGNUP_STATUS";
export const SET_SIGNUP_ATTEMPT = "SET_SIGNUP_ATTEMPT";
export const SET_SIGNUP_EMAIL = "SET_SIGNUP_EMAIL";
export const SET_SIGNUP_ACCOUNT = "SET_SIGNUP_ACCOUNT";
export const SET_SIGNUP_PROPERTIES = "SET_SIGNUP_PROPERTIES";
export const SET_RESETPASSWORD_LOADING = "SET_RESETPASSWORD_LOADING";

// This is a left-over from the simpler signup form. The error fields are no longer used.
export const signUpStatusReasons = {
    none: {
        code: "NONE",
        text: "",
        errorFields: {
            firstName: false,
            lastName: false,
            phoneNumber: false,
            email: false,
            password: false,
            confirmPassword: false,
        },
    },
    passMismatch: {
        code: "PASS_MISMATCH",
        text: "Passwords don't match.",
        errorFields: {
            firstName: false,
            lastName: false,
            phoneNumber: false,
            email: false,
            password: true,
            confirmPassword: true,
        },
    },
    emailRegistered: {
        code: "EMAIL_REGISTERED",
        text: "The given email has already been taken.",
        errorFields: {
            firstName: false,
            lastName: false,
            phoneNumber: false,
            email: true,
            password: false,
            confirmPassword: false,
        },
    },
    success: {
        code: "SUCCESS",
        errorFields: {
            firstName: false,
            lastName: false,
            phoneNumber: false,
            email: false,
            password: false,
            confirmPassword: false,
        },
    },
    unknown: {
        code: "UNKNOWN",
        text: "Sorry, but something went wrong",
        errorFields: {
            firstName: true,
            lastName: true,
            phoneNumber: true,
            email: true,
            password: true,
            confirmPassword: true,
        },
    },
};

export function clearSignUpStatus() {
    return {
        type: CLEAR_SIGNUP_STATUS,
    };
}

export function setSignUpAttempt(status, reason) {
    return {
        type: SET_SIGNUP_ATTEMPT,
        status: status,
        reason: reason,
    };
}

export function setSignUpEmail(email) {
    return {
        type: SET_SIGNUP_EMAIL,
        email: email,
    };
}

export function setSignUpAccount(account) {
    return {
        type: SET_SIGNUP_ACCOUNT,
        account: account,
    };
}

export function setSignUpProperties(properties) {
    return {
        type: SET_SIGNUP_PROPERTIES,
        properties: properties,
    };
}

export const setResetPasswordLoading = bool => ({
    type: SET_RESETPASSWORD_LOADING,
    bool,
});

export const resetPassword = (email, cb = () => { }) => async dispatch => {
    dispatch(setResetPasswordLoading(true));
    try {
        const response = await axios.post(`${baseUrl}/user/reset`, {
            email,
        });
        cb();
        dispatch(setResetPasswordLoading(false));
    } catch (error) {
        dispatch(setResetPasswordLoading(false));
        console.log("PASSWORD RESET ERROR >>", error);
        dispatch(showError(error.response.data.message));
    }
};

export function translateProperties(post) {
    const translatedValues = {
        ...post,
        ...translateObjectToNumberArray(post, "rooms"),
        ...translateObjectToStringArray(post, "residenceType"),
        ...translateObjectToStringArray(post, "floor"),
        ...translateObjectToStringArray(post, "wc"),
        ...translateObjectToStringArray(post, "locationTags"),
        ...translateObjectToStringArray(post, "parking"),
        ...translateObjectToStringArray(post, "responsibilityFactors"),
        ...translateLocation(post.location),
    };

    if (typeof translatedValues.residenceType === "string") {
        translatedValues.residenceType = [translatedValues.residenceType];
    } else if (!translatedValues.residenceType) {
        translatedValues.residenceType = [];
    }

    Object.keys(translatedValues).forEach(key => {
        if (translatedValues[key] === "") {
            translatedValues[key] = null;
        }
    });

    return translatedValues;
}

export function signUp(form) {
    return (dispatch, getState) => {
        dispatch(
            setSignUpAttempt(requestState.inProgress, signUpStatusReasons.none)
        );
        let signUp = {};
        try {
            signUp = translateProperties(form);
            if (signUp.password !== signUp.confirmPassword && signUp.password) {
                dispatch(
                    setSignUpAttempt(
                        requestState.fail,
                        signUpStatusReasons.passMismatch
                    )
                );
                return;
            }
        } catch (error) {
            console.log("signUp - ERROR >>", error);
            dispatch(
                setSignUpAttempt(requestState.fail, signUpStatusReasons.unknown)
            );
            return;
        }
        axios
            .post(`${baseUrl}/users`, signUp)
            .then(response => {
                dispatch(
                    setSignUpAttempt(
                        requestState.success,
                        signUpStatusReasons.success
                    )
                );
                dispatch(reset("signup"));
                dispatch(reset("landlordSignup"));
                // const user = response.data;
                console.log("SIGNUP SUCCESS >>", response.data); // DEBUG
                // axios.post( `${baseUrl}/properties/user/` )
            })
            .catch(error => {
                console.log("SIGNUP ERROR >>", error);
                const errorMessage = error.response.data.message;
                dispatch(showError(error.response.data.message));
                if (
                    errorMessage ===
                    "There is already user with those credentials"
                )
                    dispatch(
                        setSignUpAttempt(
                            requestState.fail,
                            signUpStatusReasons.emailRegistered
                        )
                    );
                else
                    dispatch(
                        setSignUpAttempt(
                            requestState.fail,
                            signUpStatusReasons.unknown
                        )
                    );
            });
    };
}

export function landlordSignUp(account) {
    return (dispatch, getState) => {
        const properties = getState().signUp.properties;
        if (!properties) {
            console.error("Properties are null"); // DEBUG
        } else {
            dispatch(
                signUp({
                    isLandlord: true,
                    ...properties,
                    ...account,
                })
            );
        }
    };
}
